import { useEffect, useCallback } from "react";

import { useNavigate } from "react-router-dom";

import {
  LoginBodiesAuthFlow,
  useLoginHook,
  useVerifyHook,
} from "../api-client";

export const Session = () => {
  const navigate = useNavigate();
  const verify = useVerifyHook();
  const login = useLoginHook();
  const observeAuth = useCallback(async () => {
    const idToken = localStorage.getItem("idToken");

    if (!idToken) {
      localStorage.clear();
      return;
    }
    try {
      await verify();
    } catch (e: any) {
      try {
        // refreshTokenによってidTokenを最新化する
        const result = await login({
          refreshToken: localStorage.getItem("refreshToken")!,
          authFlow: LoginBodiesAuthFlow.REFRESH_TOKEN_AUTH,
        });
        if (
          (result?.data?.idToken && result?.data?.accessToken,
          result?.data?.refreshToken)
        ) {
          /*setToken(
            result?.data.idToken,
            result?.data.accessToken,
            result?.data.refreshToken
          );*/
          localStorage.idToken = result?.data.idToken;
          localStorage.accessToken = result?.data.accessToken;
          localStorage.refreshToken = result?.data.refreshToken;
        }
      } catch (e) {
        localStorage.clear();
        navigate("/login");
      }
      return;
    }
  }, [verify, login, navigate]);

  useEffect(() => {
    observeAuth();
    // eslint-disable-next-line
  }, [observeAuth]);

  return <>{null}</>;
};
